/**
 * returns a unique state name based on current state names already in use
 * @param {string[]} pStates an array of state names
 * @param {string} pTargetStateName new state name
 * @returns {string} the unique state name
 */
export const getUniqueStateName = (pStates, pTargetStateName) => {
  const lStateNames = pStates.reduce((prev, current) => {
    prev[current] = true;
    return prev;
  }, {});

  let lUniqueStateName = pTargetStateName;
  let lDefaultStateSuffix = 0;

  while(lUniqueStateName in lStateNames) {
    lDefaultStateSuffix++;
    lUniqueStateName = `${pTargetStateName}${lDefaultStateSuffix}`;
  }

  return lUniqueStateName;
};


// returns a default model when addeing the next state
export const getDefaultTargetState = (pStates) => ({
  "stateName": pStates[0].stateName,
  "eventType": "mqtt",
  "eventDefinition": "",
  "guardExpression": ""
});

